export const API_BASE_URL = 'https://api.beaive.com';

export const getWhatsAppSabaiUrl = (userId: string) => {
  const text = encodeURIComponent("Hi Sabai! I’m new here.");
  return `https://api.whatsapp.com/send/?phone=66654868352&text=${text}&consented_at=2026-06-18T13:45:00Z&consent_version=v1.0&report_analysis=true&type=phone_number&app_absent=0&beaive_user_id=${userId}`;
};
